<template>
  <div class="fix-top">
    <a @click="play">
      <img
        v-if="isPlay"
        class="music music_close"
        :src="require(`@img/music_open.png`)"
      />
      <img v-else class="music music_open" :src="require(`@img/music_close.png`)" />
    </a>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { sound } from "../utils/loader";
// pixi sound
let isPlay = ref(false);

const play = () => {
  isPlay.value = !isPlay.value;
  if (isPlay.value) {
    sound.play({
      loop: true,
    });
  } else {
    sound.stop();
  }
};

function replayAudio() {
  sound.currentTime = 0; // 将播放时间设置为 0
  sound.play(); // 重新播放音频
}
</script>
<style lang="scss" scoped>
.fix-top {
  position: fixed;
  right: fixedRight(10);
  top: 10px;
  z-index: 10;

  @media (max-width: $containerWidth) {
    right: 10px;
  }
}

.music {
  width: 70px;
  @media (max-width: $containerWidth) {
    width: pxToVw(70px);
  }

  &.music_open {
    animation: zoom-in-zoom-out 1s ease infinite;
  }
  // &.music_close {
  //   animation: rotation 2s infinite linear;
  // }
}
</style>
